export const MODEL = [
  "296 GTB",
  "4Runner",
  "500",
  "718",
  "911",
  "A-Class",
  "A2",
  "A3",
  "A4",
  "A6",
  "A7",
  "A8",
  "Accord",
  "Alpine",
  "Arteon",
  "Atlas",
  "Avalon",
  "Aventador",
  "Aviator",
  "Blazer",
  "Bronco",
  "C-Class",
  "C-HR",
  "Camaro",
  "Camry",
  "Cayenne",
  "Chiron",
  "Civic",
  "Clarity",
  "Clubman",
  "Colorado",
  "Corolla",
  "Corsair",
  "Corvette",
  "Countryman",
  "CR-V",
  "CT-4",
  "CT-5",
  "CX-9",
  "Duster",
  "e-tron",
  "E-Class",
  "Edge",
  "Elantra",
  "Escalade",
  "EQS",
  "EV-6",
  "Expedition",
  "Explorer",
  "F-150",
  "Fiesta",
  "Forester",
  "Ghibli",
  "Giulia",
  "GR86",
  "Grand Cherokee",
  "Grecale",
  "Golf",
  "Highlander",
  "HR-V",
  "Huracan",
  "ID.4",
  "Impreza",
  "Insight",
  "Ioniq",
  "Jetta",
  "John Cooper Works",
  "Kona",
  "Land Cruiser",
  "Legacy",
  "Levante",
  "Logan",
  "Lyriq",
  "M3",
  "M4",
  "M5",
  "Macan",
  "Malibu",
  "Maverick",
  "Mirai",
  "Model 3",
  "Model S",
  "Model X",
  "Model Y",
  "Mustang",
  "Nautilus",
  "Navigator",
  "Niro",
  "Outback",
  "Odyssey",
  "Palisade",
  "Panamera",
  "Passat",
  "Passport",
  "Portofino",
  "Prius",
  "Q3",
  "Q4",
  "Q5",
  "Q6",
  "Q7",
  "Q8",
  "Quattroporte",
  "Ranger",
  "R8",
  "RAV4",
  "Rio",
  "Roma",
  "S-Class",
  "Sandero",
  "Santa fe",
  "Sequoia",
  "Sentra",
  "Sienna",
  "Silverado",
  "Sonata",
  "Sorento",
  "Spark",
  "Sportage",
  "Spring",
  "Stelvio",
  "Stinger",
  "Suburban",
  "Super Duty",
  "Supra",
  "Tacoma",
  "Tahoe",
  "Tacoma",
  "Taos",
  "Taurus",
  "Taycan",
  "Tiguan",
  "Tonale",
  "Touareg",
  "Trailblazer",
  "TT",
  "Tucson",
  "Tundra",
  "Urus",
  "Veloster",
  "Venza",
  "Veyron",
  "Wrangler",
  "X1",
  "X2",
  "X3",
  "X4",
  "X5",
  "X6",
  "X7",
  "XT4",
  "XT5",
  "Yaris",
  "Z4",
];
